<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="searchbox">
			<div>
				<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword"
					@keyup.enter.native="clickSearch" clearable size="small"></el-input>
				<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
			</div>
			<div style="flex: 1;text-align: right;">
				<el-button icon="el-icon-plus" type="warning" @click='addpetgift()' size="small">新建礼包</el-button>
			</div>
		</div>
		<div class="con" :style="{height:fixedHeight-82+'px'}">
			<div class="left">
				<el-tree style="margin-top: 10px;" v-if="categoryData[0]" :data="categoryData[0].children"
					:highlight-current='isHighlight' node-key="id" default-expand-all :expand-on-click-node="false"
					@node-click='handleNodeClick'>
				</el-tree>
			</div>
			<div class="table">
				<el-table :data="petgiftData" style="width: 100%" size="small">
					<el-table-column label="名称" prop="title" align="center">
					</el-table-column>
					<el-table-column prop="pet_grade" label="分类" align="center">
						<template slot-scope="scope">
							<span> {{scope.row.category_info.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="级别" align="center">
						<template slot-scope="scope">
							<span> {{scope.row.gift_bag_level.title}}</span>
						</template>
					</el-table-column>
					<el-table-column label="简介" prop="desc" align="center">
					</el-table-column>
					<el-table-column label="价格" align="center">
						<template slot-scope="scope">
							<span> {{scope.row.gift_bag_plans[0].price}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180px" align="center">
						<template slot-scope="scope">
							<el-button type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.giftBagId)'>
								编辑
							</el-button>
							<el-button type="text" size="small" @click='deletegiftbag(scope.row.giftBagId)'>删除
							</el-button>
							<!-- <el-button v-if="scope.row.status==2" type="text" icon='el-icon-view' size="small"
								@click='stop(scope.row.giftBagId,scope.row.title)'>下架</el-button> -->

						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.pageIndex" :pageSize='params.pageSize' @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>

	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import {
		getPetGiftList,
		getProductType,
		getPetType,
		deletePetGift
	} from '../../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				params: {
					pageIndex: 1,
					pageSize: 10,
					categoryId: '',
					keyword: '',
				},
				total: 0,
				categoryData: [],
				isHighlight: true,
				petgiftData: [],
				petType: [],
				fixedHeight:'',
			}
		},
		created(){
			this.fixedHeight = document.documentElement.clientHeight - 86;
		},
		methods: {
			getPetGiftList() {
				getPetGiftList(this.params).then(res => {
					if (res.code == 0) {
						console.log(res.data.data)
						this.petgiftData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getProductType() {
				getProductType({
					category: '礼包'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data;
					}
				})
			},
			changePage(val) {
				this.params.pageIndex = val;
				this.getPetGiftList();
			},
			clickSearch() {
				this.params.pageIndex = 1;
				this.getPetGiftList();
			},
			handleNodeClick(data) {
				this.params.categoryId = data.id;
				this.getPetGiftList();
			},
			getPetType() {
				getPetType({
					type: '品级',
					class: '宠物',
				}).then(res => {
					if (res.code == 0) {
						this.petType = res.data.data;
					}
				})
			},
			edit(id) {
				this.$router.push({
					path: '/petgift/edit',
					query: {
						id
					}
				})
			},
			addpetgift() {
				this.$router.push({
					path: '/petgift/edit'
				})
			},
			deletegiftbag(id) {
				this.$confirm('请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deletePetGift({
						id,
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getPetGiftList();
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}
		},
		mounted() {
			this.getPetGiftList();
			this.getProductType();
			// this.getPetType();
		}
	}
</script>

<style lang="scss" scoped>
	.searchbox {
		font-size: 14px;
		height: 72px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		background: #fff;
	}

	.con {
		display: flex;
		margin-top: 10px;

		.left {
			width: 180px;
			background-color: #fff;
			margin-right: 20px;
			padding: 10px;
			overflow-y: scroll;
		}

		.table {
			flex: 1;
			background-color: #fff;
		}
	}
</style>
